import { render } from "./EventDetails.vue?vue&type=template&id=45ec1070&scoped=true"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"

import "./EventDetails.vue?vue&type=style&index=0&id=45ec1070&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-45ec1070"

export default script